import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView"
import { TreeItem } from "@mui/x-tree-view/TreeItem"
import { ContractFamilyInfo } from "@store/authAtoms"
import { Typography } from "@mui/material"

type MyPermissionDialogProps = {
  permissions: { [p: string]: ContractFamilyInfo[] | undefined } | null
  open: boolean
  setOpen: (value: ((prevState: boolean) => boolean) | boolean) => void
}

export default function MyPermissionDialog({
  open,
  setOpen,
  permissions,
}: MyPermissionDialogProps) {
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="dialog-title">
      <DialogTitle id="dialog-title">{"Contract-User Permissions"}</DialogTitle>
      <DialogContent sx={{ minWidth: 400 }}>
        <Typography>
          Note: Contract / role configuration alone do not dictate visibility! Consider the owner of
          the graph; whether the graph is published; the graphs M.m.p version; and the area of the
          application you are accessing.
        </Typography>
        <SimpleTreeView aria-label="Permissions">
          {permissions &&
            Object.keys(permissions).map((key: string) => {
              return (
                <TreeItem
                  key={key}
                  itemId={key}
                  label={key}
                  sx={{
                    "& .MuiTreeItem-label": {
                      wordBreak: "break-all",
                      fontWeight: 800,
                    },
                  }}
                >
                  {permissions[key]?.map((item: ContractFamilyInfo) => {
                    return (
                      <TreeItem
                        key={item.contract_key}
                        itemId={key + item.contract_key}
                        label={item.contract_key}
                        sx={{
                          "& .MuiTreeItem-label": {
                            wordBreak: "break-all",
                            fontWeight: 300,
                          },
                        }}
                      >
                        <ul>
                          {item.families.map((family) => (
                            <li key={family}>{family}</li>
                          ))}
                        </ul>
                      </TreeItem>
                    )
                  })}
                </TreeItem>
              )
            })}
        </SimpleTreeView>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} autoFocus={true} variant={"contained"}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
